import { Rol } from '@/shared/dtos/rol';
import { User } from '@/shared/dtos/user';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { store } from '@/iti-core-vue/store';
import { itiHttpService, ItiString, itiTokenService } from '@/iti-core-vue';
import { API } from '@/shared';
import { CollaborativeAreaMember } from '@/shared/dtos/collaborative-area-member';

@Module({
    namespaced: true,
    name: 'UserModule',
    store,
    dynamic: true,
})
class UserModule extends VuexModule {

    public users: User[] = [];
    public userSelect: User = new User();
    public roles: Rol[] = [];
    public normalRoles: Rol[] = [];
    public ambitRoles: Rol[] = [];
    public userRoles: Rol[] = [];
    public usersNotInArea: User[] = [];
    public userRoleInArea: CollaborativeAreaMember = new CollaborativeAreaMember();
    public userSession: User = new User();

    @Mutation
    public resetState(): void {
        this.users = [];
        this.userSelect = new User();
    }

    @Action
    public async getUsers() {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.get(API.user);
        this.context.commit('updateUsers', res);
    }

    @Action
    public async getUser(id: number) {
        if (!itiTokenService.hasToken()) { return; }
        const apiUser = ItiString.Format(API.userDetail, id);
        const res = await itiHttpService.get(apiUser);
        this.context.commit('updateUserSelect', res);
    }

    @Mutation
    public updateUserSelect(item: User) {
        this.userSelect = item;
    }

    @Mutation
    public updateUsers(items: User[]) {
        this.users = items;
    }

    @Action
    public async modificarUsuario(item: User) {
        if (!itiTokenService.hasToken()) { return; }
        const apiUpdateUser = ItiString.Format(API.userDetail, item.id);
        try {
            const res = await itiHttpService.put(apiUpdateUser, item, false);
        } catch {
            // ...
        }
        this.context.dispatch('getUsers');
    }

    @Action
    public async getRoles() {
        if (!itiTokenService.hasToken()) { return; }
 
        const res = await itiHttpService.get(API.allRoles);
  
        this.context.commit('updateRoles', res);
    }

    @Mutation
    public updateRoles(items: Rol[]) {
        this.roles = items;
    }
    @Action
    public async getAmbitRoles() {
        if (!itiTokenService.hasToken()) { return; }

        const res = await itiHttpService.get(API.ambitRoles);

        this.context.commit('updateAmbitRoles', res);
    }

    @Mutation
    public updateAmbitRoles(items: Rol[]) {
        this.ambitRoles = items;
    }

    @Action
    public async getNormalRoles() {
        if (!itiTokenService.hasToken()) { return; }

        const res = await itiHttpService.get(API.roles);

        this.context.commit('updateNormalRoles', res);
    }

    @Mutation
    public updateNormalRoles(items: Rol[]) {
        this.normalRoles = items;
    }
    @Action
    public async getUserRoles() {
        if (!itiTokenService.hasToken()) { return; }
        const apiGetUserRoles = ItiString.Format(API.userRoles, this.userSelect.id);
        const res = await itiHttpService.get(apiGetUserRoles);
        this.context.commit('updateUserRoles', res);
    }

    @Mutation
    public async updateUserRoles(items: Rol[]) {
        this.userRoles = items;
    }

    @Action
    public async deleteUserRole(item: Rol){
        if (!itiTokenService.hasToken()) { return; }
        const apiDeleteRole = ItiString.Format(API.deleteUserRole, this.userSelect.id, item.id);
        const res = await itiHttpService.delete(apiDeleteRole, null);

        this.context.dispatch('getUserRoles');
    }

    @Action
    public async addUserRole(roleSelect: number) {
        if (!itiTokenService.hasToken()) { return; }
        const apiAddRole = ItiString.Format(API.addUserRole, this.userSelect.id, roleSelect);
        const res = await itiHttpService.post(apiAddRole, null);
        this.context.dispatch('getUserRoles');
    }

    @Mutation
    public setUsersByAmbitId(users: User[]) {
        this.users = users;
    }

    @Action
    public async getUsersByAmbitId(ambitId: number) {
        const res = await itiHttpService.get(API.user + '/GetUsersByAmbitId?ambitId=' + ambitId);
        this.context.commit('setUsersByAmbitId', res);
    }

    @Mutation
    public setUsersNotInCollaborativeArea(users: User[]) {
        this.usersNotInArea = users;
    }

    @Action
    public async getUsersNotInCollaborativeArea(ambitId: number) {
        const res = await itiHttpService.get(API.user + '/GetUsersNotInCollaborativeArea?ambitId=' + ambitId);
        this.context.commit('setUsersNotInCollaborativeArea', res);
    }

    @Action
    public async getCollaborativeAreaRoles() {
        if (!itiTokenService.hasToken()) { return; }
 
        const res = await itiHttpService.get(API.user + '/GetCollaborativeAreaRoles');
  
        this.context.commit('updateRoles', res);
    }

    @Mutation
    public setUserRoleInArea(userRole: CollaborativeAreaMember) {
        this.userRoleInArea = userRole;
    }

    @Action
    public async getUserRoleInArea(ambitId: number) {
        const res = await itiHttpService.get(API.user + '/GetUserRoleInArea?ambitId=' + ambitId);
        this.context.commit('setUserRoleInArea', res); 
    }

    @Mutation
    public setUserSession(user: User) {
        this.userSession = user;
    }

    @Action
    public async getUserSession() {
        const res: User = await itiHttpService.get(API.user + '/GetUserSession');
        this.context.commit('setUserSession', res); 
    }

    @Action
    public async UpdateUserSession(user: User) {
        await itiHttpService.put(API.user + '/UpdateUserSession?name=' + user.completeUser + '&bussinesName=' + user.businessName
        + '&address=' + user.address + '&cnaeId=' + user.cnaeCodeId + '&assosiationId=' + user.associationId,'');
    }

}
export default getModule(UserModule);
